export default __webpack_public_path__ + "static/cuidamos-8531bbd25f75f9c9a36fe05cc739be97.png";